<template>
  <div>
    <Header>Student Schedule Page</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mx-auto my-4">
        <div class="flex flex-col items-center gap-4"
          v-if="studentDbId === undefined">
          <span>
            Please select a student in Student List
          </span>
          <Button
            class="w-1/3"
            color="gray"
            size="md"
            @click="toStudentList()">
            Student List
          </Button>
        </div>
        <div class="flex flex-col"
          v-show="studentDbId !== undefined">
          <div v-if="studentName">
            <div class="flex flex-row m-4">
              <div class="text-xl mx-2">
                {{ studentName }}
              </div>
              <div>---</div>
              <div class="text-xl font-bold mx-2">
                {{ studentInternalId }}
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-xl m-4">
              Loading Student
            </div>
          </div>
          <ScheduleAggregate
            :studentDbId="studentDbId"
            :defaultSelection="defaultSelection"
          />
        </div>
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import user from '../services/user/user.js'

import Main from '../components/Main.vue'
import Header from '../components/Header.vue'
import Button from '../components/Button.vue'

import ScheduleAggregate from '../components/schedule/ScheduleAggregate.vue'

import studentSchedulePageService from '../services/pages/studentSchedulePage.js'

export default {
  components: {
    Main,
    Header,
    Button,
    ScheduleAggregate,
  },
  data() {
    return {
      mapComponentKey: 0,
      studentDbId: undefined,

      student: undefined,

      defaultSelection: {
        schedule: {
          type: 'current',
        }
      }
    }
  },
  methods: {
    toStudentList() {
      this.$router.push({
        name: 'StudentList'
      })
    },
    setSchedule(scheduleType) {
      this.scheduleType = scheduleType
    },
    setScheduleIndex(newIndex) {
      this.scheduleIndex = newIndex
    },
    setCompareSchedule(scheduleType) {
      this.compareScheduleType = scheduleType
    },
    checkUserCanViewPage() {
      if (!this.user.can('view_developer_debug_data')) {
        this.$router.push({
          path: '/'
        })
        return true
      }
    },
  },
  async mounted() {
    this.studentDbId = parseInt(this.$route.params.studentDbId)
    if (!this.studentDbId) {
      this.studentDbId = parseInt(this.$route.query.studentDbId)
    }

    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }
    this.student = await studentSchedulePageService.getStudentDetail(this.studentDbId)
  },
  watch: {
    '$router.params.studentDbId': function (newValue) {
      this.studentDbId = parseInt(newValue)
    },
  },
  computed: {
    studentName() {
      if (this.student === undefined) {
        return undefined
      }
      return `${this.student.firstName} ${this.student.lastName}`
    },
    studentInternalId() {
      return this.student?.internalId
    },
  },
}
</script>
